import { AxiosInstance } from 'axios';

const cancel_groups: Array<CancelGroup> = [];

interface CancelGroup {
   page_name: string;
   group_name: string | null;
   controller?: AbortController;
}

const useGroupedRequest = async (
   url: string,
   page_name: string,
   group_name: string | null = null,
   params?: any,
   instance: AxiosInstance = api,
) => {
   let cancel_group: CancelGroup | undefined = cancel_groups.find(
      (group) => group.page_name === page_name && group.group_name === group_name,
   );

   if (!cancel_group) {
      cancel_group = { page_name, group_name, controller: new AbortController() };
      cancel_groups.push(cancel_group);
   }

   let axios_options = {
      params,
      signal: cancel_group.controller?.signal,
   };
   return await instance.get(url, axios_options);
};

const useAbortGroupRequests = (page_name: string, group_name: string) => {
   const cancel_group = cancel_groups.find((group) => group.page_name === page_name && group.group_name === group_name);
   if (!cancel_group) return;
   cancel_group?.controller?.abort();
   cancel_groups.splice(cancel_groups.indexOf(cancel_group), 1);
};

const useAbortPageRequests = (page_name: string) => {
   cancel_groups.filter((group) => group.page_name === page_name).forEach((group) => useAbortGroupRequests(page_name, group.group_name!));
};

export { useGroupedRequest, useAbortGroupRequests, useAbortPageRequests };
